<app-main-contents>
  <app-title [title]="title"></app-title>
  <app-create-customer-form
    *ngIf="organizationCd"
    [organizationCd]="organizationCd"
  ></app-create-customer-form>
</app-main-contents>
